import {px} from './px';

export const makeBoxShadow = (
  x: string,
  y: string,
  blur: string,
  spread: string,
  color: string
) => [px(x), px(y), px(blur), px(spread), color].join(' ');